import {
    CREATE_TPC_COURSE_REQUEST,
    CREATE_TPC_COURSE_FAILURE,
    CREATE_TPC_COURSE_RESET,
    CREATE_TPC_COURSE_SUCCESS,
    FETCH_TPC_COURSES_FAILURE,
    FETCH_TPC_COURSES_REQUEST,
    FETCH_TPC_COURSES_SUCCESS,
    UPDATE_TPC_COURSE_FAILURE,
    UPDATE_TPC_COURSE_REQUEST,
    UPDATE_TPC_COURSE_RESET,
    UPDATE_TPC_COURSE_SUCCESS,
    DELETE_TPC_COURSE_FAILURE,
    DELETE_TPC_COURSE_REQUEST,
    DELETE_TPC_COURSE_RESET,
    DELETE_TPC_COURSE_SUCCESS,

    CREATE_TPC_COURSE_CATEGORY_REQUEST,
    CREATE_TPC_COURSE_CATEGORY_FAILURE,
    CREATE_TPC_COURSE_CATEGORY_RESET,
    CREATE_TPC_COURSE_CATEGORY_SUCCESS,

    CREATE_TPC_COURSE_LESSONS_REQUEST,
    CREATE_TPC_COURSE_LESSONS_FAILURE,
    CREATE_TPC_COURSE_LESSONS_RESET,
    CREATE_TPC_COURSE_LESSONS_SUCCESS,

    UPDATE_TPC_COURSE_CATEGORY_ORDER_REQUEST,
    UPDATE_TPC_COURSE_CATEGORY_ORDER_FAILURE,
    UPDATE_TPC_COURSE_CATEGORY_ORDER_RESET,
    UPDATE_TPC_COURSE_CATEGORY_ORDER_SUCCESS,

    UPDATE_TPC_COURSE_CATEGORY_REQUEST,
    UPDATE_TPC_COURSE_CATEGORY_FAILURE,
    UPDATE_TPC_COURSE_CATEGORY_RESET,
    UPDATE_TPC_COURSE_CATEGORY_SUCCESS,

    UPDATE_TPC_COURSE_LESSONS_REQUEST,
    UPDATE_TPC_COURSE_LESSONS_FAILURE,
    UPDATE_TPC_COURSE_LESSONS_RESET,
    UPDATE_TPC_COURSE_LESSONS_SUCCESS,

    DELETE_TPC_COURSE_LESSONS_REQUEST,
    DELETE_TPC_COURSE_LESSONS_FAILURE,
    DELETE_TPC_COURSE_LESSONS_RESET,
    DELETE_TPC_COURSE_LESSONS_SUCCESS,

    DELETE_TPC_COURSE_CATEGORY_REQUEST,
    DELETE_TPC_COURSE_CATEGORY_FAILURE,
    DELETE_TPC_COURSE_CATEGORY_RESET,
    DELETE_TPC_COURSE_CATEGORY_SUCCESS,

    UPDATE_MARKED_COMPLETE_LESSON_REQUEST,
    UPDATE_MARKED_COMPLETE_LESSON_FAILURE,
    UPDATE_MARKED_COMPLETE_LESSON_RESET,
    UPDATE_MARKED_COMPLETE_LESSON_SUCCESS,

    FETCH_MARKED_COMPLETE_LESSON_REQUEST,
    FETCH_MARKED_COMPLETE_LESSON_FAILURE,
    FETCH_MARKED_COMPLETE_LESSON_RESET,
    FETCH_MARKED_COMPLETE_LESSON_SUCCESS,

    CREATE_BUNDLECOURSE_REQUEST,
    CREATE_BUNDLECOURSE_SUCCESS,
    CREATE_BUNDLECOURSE_FAILURE,
    CREATE_BUNDLECOURSE_RESET,

    FETCH_BUNDLECOURSE_REQUEST,
    FETCH_BUNDLECOURSE_SUCCESS,
    FETCH_BUNDLECOURSE_FAILURE,
    FETCH_BUNDLECOURSE_RESET,

    SAVE_COURSES_ORDER_FAILURE,
    SAVE_COURSES_ORDER_REQUEST,
    SAVE_COURSES_ORDER_SUCCESS,
    SAVE_COURSES_ORDER_RESET,

    SEARCH_TPC_COURSES_REQUEST,
    SEARCH_TPC_COURSES_SUCCESS,
    SEARCH_TPC_COURSES_FAILURE,
    SEARCH_TPC_COURSES_RESET,
    FETCH_LESSON_TRANSCRIPT_REQUEST,
    FETCH_LESSON_TRANSCRIPT_SUCCESS,
    FETCH_LESSON_TRANSCRIPT_FAILURE,
    FETCH_LESSON_TRANSCRIPT_RESET,
    FETCH_TPC_COURSES_RESET

} from "./ManageTpcCoursesTypes"
import axios from "axios"
import { getActiveSpecialty } from "util/specialtyCollections"

export const createTpcCourseReset = () => {
    return {
        type: CREATE_TPC_COURSE_RESET,
    }
}

const createTpcCourseRequest = () => {
    return {
        type: CREATE_TPC_COURSE_REQUEST,
    }
}

const createTpcCourseSuccess = success => {
    return {
        type: CREATE_TPC_COURSE_SUCCESS,
        payload: success
    }
}

const createTpcCourseFailure = error => {
    return {
        type: CREATE_TPC_COURSE_FAILURE,
        payload : error
    }
}

export const createTpcCourse = (data) => {

    return (dispatch, getState) => {

        dispatch(createTpcCourseRequest());

        data.append('specialty', getActiveSpecialty(getState));

        axios.post('/createTpcCourse', data,{headers: {
            'Content-Type': 'multipart/form-data'

          }})
        .then(response => {
            const TpcCourse = response.data
            dispatch(createTpcCourseSuccess(TpcCourse))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createTpcCourseFailure(errorMsg))
        })

    }

}


const fetchTpcCoursesRequest = () => {
    return {
        type: FETCH_TPC_COURSES_REQUEST,
    }
}

const fetchTpcCoursesSuccess = success => {
    return {
        type: FETCH_TPC_COURSES_SUCCESS,
        payload: success
    }
}

const fetchTpcCoursesFailure = error => {
    return {
        type: FETCH_TPC_COURSES_FAILURE,
        payload : error
    }
}

export const fetchTpcCourses = (data) => {

    return (dispatch, getState) => {

        dispatch(fetchTpcCoursesRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/getTpcCourses' , { ...data, specialty })
        .then(response => {
            const TpcCourses = response.data
            dispatch(fetchTpcCoursesSuccess(TpcCourses))


        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchTpcCoursesFailure(errorMsg))
        })

    }

}


export const fetchTpcCoursesReset = () => {
    return {
        type: FETCH_TPC_COURSES_RESET
    }
}

export const updateTpcCourseReset = () => {
    return {
        type: UPDATE_TPC_COURSE_RESET,
    }
}

const updateTpcCourseRequest = () => {
    return {
        type: UPDATE_TPC_COURSE_REQUEST,
    }
}

const updateTpcCourseSuccess = success => {
    return {
        type: UPDATE_TPC_COURSE_SUCCESS,
        payload: success
    }
}

const updateTpcCourseFailure = error => {
    return {
        type: UPDATE_TPC_COURSE_FAILURE,
        payload : error
    }
}

export const updateTpcCourse = (data) => {

    return (dispatch, getState) => {

        dispatch(updateTpcCourseRequest());

        data.append('specialty', getActiveSpecialty(getState));

        axios.post('/updateTpcCourse', data,{headers: {
            'Content-Type': 'multipart/form-data'

          }})
        .then(response => {
            const TpcCourse = response.data
            dispatch(updateTpcCourseSuccess(TpcCourse))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateTpcCourseFailure(errorMsg))
        })

    }

}

export const deleteTpcCourseReset = () => {
    return {
        type: DELETE_TPC_COURSE_RESET,
    }
}

const deleteTpcCourseRequest = () => {
    return {
        type: DELETE_TPC_COURSE_REQUEST,
    }
}

const deleteTpcCourseSuccess = success => {
    return {
        type: DELETE_TPC_COURSE_SUCCESS,
        payload: success
    }
}

const deleteTpcCourseFailure = error => {
    return {
        type: DELETE_TPC_COURSE_FAILURE,
        payload : error
    }
}

export const deleteTpcCourse = (data) => {

    return (dispatch, getState) => {

        dispatch(deleteTpcCourseRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/deleteTpcCourse', { ...data, specialty })
        .then(response => {
            const TpcCourse = response.data
            dispatch(deleteTpcCourseSuccess(TpcCourse))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(deleteTpcCourseFailure(errorMsg))
        })

    }

}

export const createTpcCourseCategoryReset = () => {
    return {
        type: CREATE_TPC_COURSE_CATEGORY_RESET,
    }
}

const createTpcCourseCategoryRequest = () => {
    return {
        type: CREATE_TPC_COURSE_CATEGORY_REQUEST,
    }
}

const createTpcCourseCategorySuccess = success => {
    return {
        type: CREATE_TPC_COURSE_CATEGORY_SUCCESS,
        payload: success
    }
}

const createTpcCourseCategoryFailure = error => {
    return {
        type: CREATE_TPC_COURSE_CATEGORY_FAILURE,
        payload : error
    }
}

export const createTpcCourseCategory = (data) => {

    return (dispatch, getState) => {

        dispatch(createTpcCourseCategoryRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/createTpcCourseCategory', { ...data, specialty })
        .then(response => {
            const TpcCourseCategory = response.data
            dispatch(createTpcCourseCategorySuccess(TpcCourseCategory))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createTpcCourseCategoryFailure(errorMsg))
        })

    }

}

export const createTpcCourseLessonsReset = () => {
    return {
        type: CREATE_TPC_COURSE_LESSONS_RESET,
    }
}

const createTpcCourseLessonsRequest = () => {
    return {
        type: CREATE_TPC_COURSE_LESSONS_REQUEST,
    }
}

const createTpcCourseLessonsSuccess = success => {
    return {
        type: CREATE_TPC_COURSE_LESSONS_SUCCESS,
        payload: success
    }
}

const createTpcCourseLessonsFailure = error => {
    return {
        type: CREATE_TPC_COURSE_LESSONS_FAILURE,
        payload : error
    }
}

export const createTpcCourseLessons = (data) => {

    return (dispatch, getState) => {

        dispatch(createTpcCourseLessonsRequest());

        data.append('specialty', getActiveSpecialty(getState));

        axios.post('/createTpcCourseLessons', data,{headers: {
            'Content-Type': 'multipart/form-data'

          }})
        .then(response => {
            const TpcCourseLessons = response.data
            dispatch(createTpcCourseLessonsSuccess(TpcCourseLessons))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createTpcCourseLessonsFailure(errorMsg))
        })

    }

}


export const updateTpcCourseCategoryOrderReset = () => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_ORDER_RESET,
    }
}

const updateTpcCourseCategoryOrderRequest = () => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_ORDER_REQUEST,
    }
}

const updateTpcCourseCategoryOrderSuccess = success => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_ORDER_SUCCESS,
        payload: success
    }
}

const updateTpcCourseCategoryOrderFailure = error => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_ORDER_FAILURE,
        payload : error
    }
}

export const updateTpcCourseCategoryOrder = (data) => {

    return (dispatch, getState) => {

        dispatch(updateTpcCourseCategoryOrderRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/updateTpcCourseCategoryOrder', { ...data, specialty })
        .then(response => {
            const TpcCourseCategory = response.data
            dispatch(updateTpcCourseCategoryOrderSuccess(TpcCourseCategory))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateTpcCourseCategoryOrderFailure(errorMsg))
        })

    }

}


export const updateTpcCourseCategoryReset = () => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_RESET,
    }
}

const updateTpcCourseCategoryRequest = () => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_REQUEST,
    }
}

const updateTpcCourseCategorySuccess = success => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_SUCCESS,
        payload: success
    }
}

const updateTpcCourseCategoryFailure = error => {
    return {
        type: UPDATE_TPC_COURSE_CATEGORY_FAILURE,
        payload : error
    }
}

export const updateTpcCourseCategory = (data) => {

    return (dispatch, getState) => {

        dispatch(updateTpcCourseCategoryRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/updateTpcCourseCategory', { ...data, specialty })
        .then(response => {
            const TpcCourseCategory = response.data
            dispatch(updateTpcCourseCategorySuccess(TpcCourseCategory))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateTpcCourseCategoryFailure(errorMsg))
        })

    }

}

export const updateTpcCourseLessonsReset = () => {
    return {
        type: UPDATE_TPC_COURSE_LESSONS_RESET,
    }
}

const updateTpcCourseLessonsRequest = () => {
    return {
        type: UPDATE_TPC_COURSE_LESSONS_REQUEST,
    }
}

const updateTpcCourseLessonsSuccess = success => {
    return {
        type: UPDATE_TPC_COURSE_LESSONS_SUCCESS,
        payload: success
    }
}

const updateTpcCourseLessonsFailure = error => {
    return {
        type: UPDATE_TPC_COURSE_LESSONS_FAILURE,
        payload : error
    }
}

export const updateTpcCourseLessons = (data) => {

    return (dispatch, getState) => {

        dispatch(updateTpcCourseLessonsRequest());

        data.append('specialty', getActiveSpecialty(getState));

        axios.post('/updateTpcCourseLessons', data,{headers: {
            'Content-Type': 'multipart/form-data'

          }})
        .then(response => {
            const TpcCourseCategory = response.data
            dispatch(updateTpcCourseLessonsSuccess(TpcCourseCategory))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateTpcCourseLessonsFailure(errorMsg))
        })

    }

}

export const deleteTpcCourseLessonsReset = () => {
    return {
        type: DELETE_TPC_COURSE_LESSONS_RESET,
    }
}

const deleteTpcCourseLessonsRequest = () => {
    return {
        type: DELETE_TPC_COURSE_LESSONS_REQUEST,
    }
}

const deleteTpcCourseLessonsSuccess = success => {
    return {
        type: DELETE_TPC_COURSE_LESSONS_SUCCESS,
        payload: success
    }
}

const deleteTpcCourseLessonsFailure = error => {
    return {
        type: DELETE_TPC_COURSE_LESSONS_FAILURE,
        payload : error
    }
}

export const deleteTpcCourseLessons = (data) => {

    return (dispatch, getState) => {

        dispatch(deleteTpcCourseLessonsRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/deleteTpcCourseLessons', { ...data, specialty })
        .then(response => {
            const TpcCourseLessons = response.data
            dispatch(deleteTpcCourseLessonsSuccess(TpcCourseLessons))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(deleteTpcCourseLessonsFailure(errorMsg))
        })

    }

}

export const deleteTpcCourseCategoryReset = () => {
    return {
        type: DELETE_TPC_COURSE_CATEGORY_RESET,
    }
}

const deleteTpcCourseCategoryRequest = () => {
    return {
        type: DELETE_TPC_COURSE_CATEGORY_REQUEST,
    }
}

const deleteTpcCourseCategorySuccess = success => {
    return {
        type: DELETE_TPC_COURSE_CATEGORY_SUCCESS,
        payload: success
    }
}

const deleteTpcCourseCategoryFailure = error => {
    return {
        type: DELETE_TPC_COURSE_CATEGORY_FAILURE,
        payload : error
    }
}

export const deleteTpcCourseCategory = (data) => {

    return (dispatch, getState) => {

        dispatch(deleteTpcCourseCategoryRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/deleteTpcCourseCategory', { ...data, specialty })
        .then(response => {
            const TpcCourseCategory = response.data
            dispatch(deleteTpcCourseCategorySuccess(TpcCourseCategory))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(deleteTpcCourseCategoryFailure(errorMsg))
        })

    }

}

export const updateMarkedCompleteLessonReset = () => {
    return {
        type: UPDATE_MARKED_COMPLETE_LESSON_RESET,
    }
}

const updateMarkedCompleteLessonRequest = () => {
    return {
        type: UPDATE_MARKED_COMPLETE_LESSON_REQUEST,
    }
}

const updateMarkedCompleteLessonSuccess = success => {
    return {
        type: UPDATE_MARKED_COMPLETE_LESSON_SUCCESS,
        payload: success
    }
}

const updateMarkedCompleteLessonFailure = error => {
    return {
        type: UPDATE_MARKED_COMPLETE_LESSON_FAILURE,
        payload : error
    }
}

export const updateMarkedCompleteLesson = (data) => {

    return (dispatch, getState) => {

        dispatch(updateMarkedCompleteLessonRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/updateMarkedCompleteLesson', { ...data, specialty })
        .then(response => {
            const MarkedCompleteLesson = response.data
            dispatch(updateMarkedCompleteLessonSuccess(MarkedCompleteLesson))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(updateMarkedCompleteLessonFailure(errorMsg))
        })

    }

}

export const fetchMarkedCompleteLessonReset = () => {
    return {
        type: FETCH_MARKED_COMPLETE_LESSON_RESET,
    }
}

const fetchMarkedCompleteLessonRequest = () => {
    return {
        type: FETCH_MARKED_COMPLETE_LESSON_REQUEST,
    }
}

const fetchMarkedCompleteLessonSuccess = success => {
    return {
        type: FETCH_MARKED_COMPLETE_LESSON_SUCCESS,
        payload: success
    }
}

const fetchMarkedCompleteLessonFailure = error => {
    return {
        type: FETCH_MARKED_COMPLETE_LESSON_FAILURE,
        payload : error
    }
}

export const fetchMarkedCompleteLesson = (data) => {

    return (dispatch, getState) => {

        dispatch(fetchMarkedCompleteLessonRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/fetchMarkedCompleteLesson', { ...data, specialty })
        .then(response => {
            const MarkedCompleteLesson = response.data
            dispatch(fetchMarkedCompleteLessonSuccess(MarkedCompleteLesson))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchMarkedCompleteLessonFailure(errorMsg))
        })

    }

}

export const createBundleCoursesReset = () => {
    return {
        type: CREATE_BUNDLECOURSE_RESET,
    }
}

const createBundleCoursesRequest = () => {
    return {
        type: CREATE_BUNDLECOURSE_REQUEST,
    }
}

const createBundleCoursesSuccess = success => {
    return {
        type: CREATE_BUNDLECOURSE_SUCCESS,
        payload: success
    }
}

const createBundleCoursesFailure = error => {
    return {
        type: CREATE_BUNDLECOURSE_FAILURE,
        payload : error
    }
}

export const createBundleCourses = (data) => {

    return (dispatch, getState) => {

        dispatch(createBundleCoursesRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/createBundleCourses', { ...data, specialty })
        .then(response => {
            const bundles = response.data
            dispatch(createBundleCoursesSuccess(bundles))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(createBundleCoursesFailure(errorMsg))
        })

    }

}

export const fetchBundleCoursesReset = () => {
    return {
        type: FETCH_BUNDLECOURSE_RESET,
    }
}

const fetchBundleCoursesRequest = () => {
    return {
        type: FETCH_BUNDLECOURSE_REQUEST,
    }
}

const fetchBundleCoursesSuccess = success => {
    return {
        type: FETCH_BUNDLECOURSE_SUCCESS,
        payload: success
    }
}

const fetchBundleCoursesFailure = error => {
    return {
        type: FETCH_BUNDLECOURSE_FAILURE,
        payload : error
    }
}

export const fetchBundleCourses = (data) => {

    return (dispatch, getState) => {

        dispatch(fetchBundleCoursesRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/fetchBundleCourses', { ...data, specialty })
        .then(response => {
            const bundleCourses = response.data
            dispatch(fetchBundleCoursesSuccess(bundleCourses))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchBundleCoursesFailure(errorMsg))
        })

    }

}


export const saveCoursesOrderReset = () => {
    return {
        type: SAVE_COURSES_ORDER_RESET,
    }
}

const saveCoursesOrderRequest = () => {
    return {
        type: SAVE_COURSES_ORDER_REQUEST,
    }
}

const saveCoursesOrderSuccess = success => {
    return {
        type: SAVE_COURSES_ORDER_SUCCESS,
        payload: success
    }
}

const saveCoursesOrderFailure = error => {
    return {
        type: SAVE_COURSES_ORDER_FAILURE,
        payload : error
    }
}

export const saveCoursesOrder = (data) => {

    return (dispatch, getState) => {

        dispatch(saveCoursesOrderRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/saveCoursesOrder', { data, specialty })
        .then(response => {
            const coursesOrder = response.data
            dispatch(saveCoursesOrderSuccess(coursesOrder))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(saveCoursesOrderFailure(errorMsg))
        })

    }

}

export const searchTpcCoursesReset = () => {
    return {
        type: SEARCH_TPC_COURSES_RESET,
    }
}

const searchTpcCoursesRequest = () => {
    return {
        type: SEARCH_TPC_COURSES_REQUEST,
    }
}

const searchTpcCoursesSuccess = success => {
    return {
        type: SEARCH_TPC_COURSES_SUCCESS,
        payload: success
    }
}

const searchTpcCoursesFailure = error => {
    return {
        type: SEARCH_TPC_COURSES_FAILURE,
        payload : error
    }
}

export const searchTpcCourses = (data) => {

    return (dispatch, getState) => {

        dispatch(searchTpcCoursesRequest());

        const specialty = getActiveSpecialty(getState);

        axios.post('/searchTpcCourses', { ...data, specialty })
        .then(response => {
            const searchResults = response.data
            dispatch(searchTpcCoursesSuccess(searchResults))

        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(searchTpcCoursesFailure(errorMsg))
        })

    }

}

export const fetchLessonTranscriptReset = () => {
    return { type: FETCH_LESSON_TRANSCRIPT_RESET }
}
export const fetchLessonTranscriptRequest = () => {
    return { type: FETCH_LESSON_TRANSCRIPT_REQUEST }
}
export const fetchLessonTranscriptSuccess = (data) => {
    return { type: FETCH_LESSON_TRANSCRIPT_SUCCESS, payload: data }
}
export const fetchLessonTranscriptFailure = (error) => {
    return { type: FETCH_LESSON_TRANSCRIPT_FAILURE, payload: error }
}
export const fetchLessonTranscript = (data) => {
    return (dispatch, getState) => {
        dispatch(fetchLessonTranscriptRequest())
        const specialty = getActiveSpecialty(getState);
        axios.post('/fetchLessonTranscript', { ...data, specialty })
        .then(response => {
            const transcript = response.data
            dispatch(fetchLessonTranscriptSuccess(transcript))
        })
        .catch(error => {
            const errorMsg = error.message
            dispatch(fetchLessonTranscriptFailure(errorMsg))
        })
    }
}
